import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Circle } from 'theme/icon';
import { I18n } from 'react-redux-i18n';
import moment from 'moment-timezone';

const Time = () => {
  const [time, setTime] = useState('00:00:00');
  const [color, setColor] = useState('#94a3b8');
  const [message, setMessage] = useState('');

  const isWinterTime = () => {
    const now = new Date();
    const janOffset = new Date(now.getFullYear(), 0, 1).getTimezoneOffset();
    const currentOffset = now.getTimezoneOffset();
    return currentOffset === janOffset;
  };

  function refreshClock() {
    setTime(new Date().toLocaleTimeString());
    const hora = moment().tz('America/New_York').format('HH');
    const minuto = moment().tz('America/New_York').format('mm');

    const setMarketOpen = () => {
      setColor('#22c55e');
      setMessage(I18n.t('open_market'));
    };

    const setMarketClosed = () => {
      setColor('#ef4444');
      setMessage(I18n.t('close_market'));
    };

    if (isWinterTime()) {
      if (hora >= 9 && hora < 16) {
        if (hora === '09' && minuto <= '29') {
          setMarketClosed();
        } else {
          setMarketOpen();
        }
      } else {
        setMarketClosed();
      }
    } else if (hora >= 8 && hora < 15) {
      if (hora === '08' && minuto <= '29') {
        setMarketClosed();
      } else {
        setMarketOpen();
      }
    } else {
      setMarketClosed();
    }
  }

  useEffect(() => {
    refreshClock();
    const timerId = setInterval(refreshClock, 1000);
    return () => clearInterval(timerId);
  }, []);

  const isOpen = color === '#22c55e';

  return (
    <div className="floating-action-time" title={message}>
      <span className="floating-action-time__clock">{time}</span>
      <Circle
        className="floating-action-time__dot"
        style={{ color }}
        aria-hidden="true"
      />
      {message ? (
        <span
          className={`floating-action-time__tooltip${
            isOpen
              ? ' floating-action-time__tooltip--open'
              : ' floating-action-time__tooltip--closed'
          }`}
          role="tooltip"
        >
          {message}
        </span>
      ) : null}
    </div>
  );
};

Time.propTypes = {
  className: PropTypes.string,
};

export default Time;
